import { atom } from "jotai";

export const boostrap     = atom({})